module.exports = __webpack_public_path__ + "img/ic-benef.0bb685dc.svg";